/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const GET_CUSTOMER_EMPLOYEE_POSITION_DESCRIPTIONS = gql`
  query GetCustomerEmployeePositionDescriptions($input: PaginationInput) {
    customerEmployeePositionDescriptions(input: $input) {
      results
      count
      hasMore
    }
  }
`
